var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-button",
        {
          directives: [
            {
              name: "has-permission",
              rawName: "v-has-permission",
              value: "ED060",
              expression: "'ED060'"
            },
            {
              name: "b-modal",
              rawName: "v-b-modal",
              value: _vm.modalName,
              expression: "modalName"
            }
          ],
          class: {
            btn: true,
            "btn-primary": !_vm.danger,
            "btn-danger": _vm.danger
          },
          attrs: { size: "sm", "data-cy": _vm.dataCy + "-selector" }
        },
        [_vm._v(" Adjuntar ")]
      ),
      _c(
        "b-modal",
        {
          attrs: {
            id: _vm.modalName,
            title: "¿Cómo desea adjuntar el documento?",
            "data-cy": "save",
            size: "sm",
            centered: "",
            "hide-footer": ""
          },
          on: { ok: _vm.handleOk }
        },
        [
          _c(
            "div",
            { staticClass: "space-y-4" },
            [
              _c("upload-file", {
                attrs: {
                  "data-cy": _vm.dataCy + "-local",
                  permission: "*",
                  accept: "application/pdf, .doc, .docx, .xlsv, .ppt",
                  text: "Desde equipo",
                  "upload-to": "ed",
                  "button-class": { "btn-md btn-block": true },
                  "container-class": "w-100"
                },
                on: { input: _vm.addLocalFile },
                model: {
                  value: _vm.listLocal,
                  callback: function($$v) {
                    _vm.listLocal = $$v
                  },
                  expression: "listLocal"
                }
              }),
              _c(
                "b-button",
                {
                  directives: [
                    {
                      name: "has-permission",
                      rawName: "v-has-permission",
                      value: "ED060",
                      expression: "'ED060'"
                    },
                    {
                      name: "b-modal",
                      rawName: "v-b-modal",
                      value: _vm.modalName + "-repository",
                      expression: "modalName+'-repository'"
                    }
                  ],
                  staticClass: "btn-block",
                  attrs: {
                    variant: "secondary",
                    size: "md",
                    "data-cy": _vm.dataCy + "-repository"
                  }
                },
                [_vm._v(" Desde repositorio ")]
              )
            ],
            1
          )
        ]
      ),
      _c("SelectDocRepository", {
        attrs: {
          "modal-id": _vm.modalName + "-repository",
          files: _vm.files,
          "add-file": _vm.addLocalFile,
          "remove-file": _vm.removeFile,
          "max-files": 1
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }